// extracted by mini-css-extract-plugin
var _1 = "styles-module__button___QnHhD";
var _2 = "styles-module__form___hpvNC";
var _3 = "styles-module__input___Kdy1s";
export { _1 as "button", _2 as "form", _3 as "input" }
